/// <reference path='userDefinedControls.module.ts' />
/// <reference path='../../../../typings/index.d.ts' />

module Meevo.Plugins.UserDefinedControls {

    import ModalTranslationModes = Meevo.Components.Modal.ModalTranslationModes;
    import ControlTypeEnum = Meevo.Model.ControlTypeEnum;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import AppAreaEnum = Meevo.Model.AppAreaEnum;
    import IUserDefinedControl = Meevo.Model.IUserDefinedControl;
    import ISearchTabCriteria = Meevo.Plugins.UserDefinedControls.ISearchTabCriteria;
    import ISearchControlCriteria = Meevo.Plugins.UserDefinedControls.ISearchControlCriteria;
    import IAppAreaTab = Meevo.Model.IAppAreaTab;

    enum PageViewEnum {
        control = 1,
        tab = 2
    }

    class UserDefinedControlsController {
        public controlTypes: Object;
        public selectedControlType: ControlTypeEnum = null;
        public controlLocations: Object;
        public selectedControlAppArea: AppAreaEnum = null;
        public selectedTabAppArea: AppAreaEnum = null;
        public controls: () => Array<IUserDefinedControl>;
        public appAreaTabs: () => Array<IAppAreaTab>;
        public view: PageViewEnum = PageViewEnum.control;
        public selectedControlByName: IUserDefinedControl = null;
        public selectedTabByName: IAppAreaTab = null;
        public statesList: Object;
        public selectedControlState: ObjectStateEnum = null;
        public selectedTabState: ObjectStateEnum = null;
        public isNotificationEnabled: boolean;

        static $inject = [
            '$rootScope',
            '$scope',
            '$state',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService',
            'meevo.components.common.IdentityService',
            'meevo.components.busy.BusyService',
            'meevo.plugins.userDefinedControls.userDefinedControlsService'
        ];

        public isSingleLocation(): boolean {
            if (Model.Guard.isSomething(this.identityService.current().isSingleLocation)) {
                return this.identityService.current().isSingleLocation;
            } else {
                return false;
            }
        }

        constructor(
            protected $rootScope: ng.IRootScopeService,
            protected $scope: ng.IScope,
            protected $state: angular.ui.IState,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected userDefinedControlsService: Meevo.Plugins.UserDefinedControls.IUserDefinedControlsService
        ) {
            this.controlTypes = this.userDefinedControlsService.controlTypes;
            this.controlLocations = this.userDefinedControlsService.controlLocations;
            this.controls = () => this.userDefinedControlsService.controls;
            this.appAreaTabs = () => this.userDefinedControlsService.appAreaTabs;
            this.statesList = {
                1: {'name': 'All', 'number': null},
                2: {'name': 'Active', 'number': ObjectStateEnum.Active},
                3: {'name': 'Inactive', 'number': ObjectStateEnum.Inactive}
            };

            this.addWatchers();
            this.searchControls();
            this.enableNotification();
        }

        /**
         * Add watchers to controller variables
         * */
        private addWatchers(): void {
            // controls search
            this.$scope.$watch(() => this.selectedControlByName, this.controlsCriteriaChanged.bind(this));
            this.$scope.$watch(() => this.selectedControlType, this.controlsCriteriaChanged.bind(this));
            this.$scope.$watch(() => this.selectedControlAppArea, this.controlsCriteriaChanged.bind(this));
            this.$scope.$watch(() => this.selectedControlState, this.controlsCriteriaChanged.bind(this));

            // tabs search
            this.$scope.$watch(() => this.selectedTabByName, this.tabsCriteriaChanged.bind(this));
            this.$scope.$watch(() => this.selectedTabAppArea, this.tabsCriteriaChanged.bind(this));
            this.$scope.$watch(() => this.selectedTabState, this.tabsCriteriaChanged.bind(this));
        }

        /**
         * Controls search criteria changed
         * @param {any} newValue
         * @param {any} oldValue
         * */
        controlsCriteriaChanged(newValue: any, oldValue: any): void {
            if (newValue === oldValue) {
                return;
            }

            this.searchControls();
        }

        /**
         * Request for enable notification option
         * */
        enableNotification(): any {
            let settings = { settings: [Meevo.Model.BusinessInfoSettingEnum.EnableAppointmentNotification] };

            this.dataService.customMethodData(`api/location/maintenance/${this.identityService.locationId}`, 'POST', settings)
                .then((res) => {
                    this.isNotificationEnabled = Number(res.data.settings[0].effectiveValue) == 1;
                });
        }

        /**
         * Make search controls request
         * */
        searchControls(): void {
            let criteria: ISearchControlCriteria,
                states: Array<ObjectStateEnum>;

            if (this.selectedControlState === null) {
                states = [ObjectStateEnum.Active, ObjectStateEnum.Inactive];
            } else {
                states = [this.selectedControlState];
            }

            criteria = {
                shortcut: this.selectedControlByName ? this.selectedControlByName.shortcut : null,
                controlTypeEnum: this.selectedControlType,
                appAreaEnum: this.selectedControlAppArea,
                objectStateEnums: states
            };

            this.busyService.start();
            this.userDefinedControlsService.search(criteria)
                .finally(() => this.busyService.stop());
        }

        /**
         * Tabs search criteria changed
         * @param {any} newValue
         * @param {any} oldValue
         * */
        tabsCriteriaChanged(newValue: any, oldValue: any): void {
            if (newValue === oldValue) {
                return;
            }

            this.searchTabs();
        }

        /**
         * Make search tabs request
         * */
        searchTabs(): void {
            let criteria: ISearchTabCriteria,
                states: Array<ObjectStateEnum>;

            if (this.selectedTabState === null) {
                states = [ObjectStateEnum.Active, ObjectStateEnum.Inactive];
            } else {
                states = [this.selectedTabState];
            }

            criteria = {
                filter: this.selectedTabByName ? this.selectedTabByName.displayName : null,
                appAreaEnum: this.selectedTabAppArea,
                objectStateEnums: states
            };

            this.busyService.start();
            this.userDefinedControlsService.searchTabs(criteria)
                .finally(() => this.busyService.stop());
        }

        /**
         * Close current tab
         * */
        closeContext(): void {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state['current'], null);
        };

        /**
         * Run adding modal
         * */
        addNewField(): void {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/userDefinedControls/add/addControl.modal.html',
                controller: 'meevo.plugins.userDefinedControls.AddControlModalController',
                controllerAs: 'vm',
                bindToController: true,
                escapeToClose: false,
                locals: {
                    isNotificationEnabled: this.isNotificationEnabled
                }
            };

            this.modalService.showCustom(options)
                .then(() => this.searchControls());
        };

        /**
         * Run assign modal
         * */
        placeNewField(): void {
            let options: Meevo.Components.Modal.IModalOptions,
                selectedControls: Array<IUserDefinedControl> = [];

            this.userDefinedControlsService.controls.forEach((item) => {
                if (item['selected']) {
                    selectedControls.push(angular.merge({}, item)); // get copy of found items
                }
            });

            if (selectedControls.length === 0) {
                this.modalService.alert("MESSAGE_PLACE_NEW_FIELD_ERR");
                return;
            }

            options = {
                templateUrl: 'app/plugins/userDefinedControls/assign/assignControl.modal.html',
                controller: 'meevo.plugins.userDefinedControls.AssignControlModalController',
                controllerAs: 'vm',
                bindToController: true,
                escapeToClose: false,
                multiple: true,
                locals: {
                    selectedControls,
                    isNotificationEnabled: this.isNotificationEnabled
                }
            };

            this.modalService.showCustom(options)
                .then(() => this.searchControls());
        }

        /**
         * Remove UDF
         * {IUserDefinedControl} userDefinedControl
         * */
        removeField(userDefinedControl: IUserDefinedControl): void {
            if (userDefinedControl.isUsed) {
                this.modalService.alert('LABEL_THE_FIELD_CANNOT_BE_DELETED', ModalTranslationModes.Translate);
                return;
            }

            this.modalService.warning('LABEL_REMOVE_UDF', ModalTranslationModes.Translate, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                .then(() => {
                    this.busyService.start();

                    this.dataService.patch('CustomData/Control', {
                        Model: {
                            entityVersion: userDefinedControl.entityVersion,
                            objectStateEnum: ObjectStateEnum.Deleted
                        }
                    }, userDefinedControl.control_TId)
                        .then(() => this.searchControls())
                        .catch(() => this.busyService.stop());
                });
        }

        /**
         * Edit UDF
         * {IUserDefinedControl} userDefinedControl
         * */
        editField(userDefinedControl: IUserDefinedControl): void {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/userDefinedControls/add/addControl.modal.html',
                controller: 'meevo.plugins.userDefinedControls.AddControlModalController',
                controllerAs: 'vm',
                bindToController: true,
                escapeToClose: false,
                locals: {
                    userDefinedControl: angular.copy(userDefinedControl)
                }
            };

            this.modalService.showCustom(options)
                .then(() => this.searchControls());
        }

        /**
         * Edit Tab
         * {IAppAreaTab} tab
         */
        editAppAreaTab(appAreaTab: IAppAreaTab): void {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/userDefinedControls/edit-tab/editTab.modal.html',
                controller: 'meevo.plugins.userDefinedControls.EditTabControlModalController',
                controllerAs: 'vm',
                bindToController: true,
                escapeToClose: false,
                locals: {
                    appAreaTab: angular.copy(appAreaTab)
                }
            };

            this.modalService.showCustom(options)
                .then(() => this.searchTabs());
        }

        /**
         * Remove Tab
         * {IAppAreaTab} tab
         */
        removeAppAreaTab(appAreaTab: IAppAreaTab): void {
            if (appAreaTab.numberOfControls) {
                this.modalService.alert('LABEL_TAB_CONTAINS_ONE_OR_MORE_FIELDS', ModalTranslationModes.Translate);
                return;
            }

            this.modalService.confirm('LABEL_REMOVE_APP_AREA_TAB', ModalTranslationModes.Translate)
                .then(() => {
                    this.busyService.start();

                    this.dataService.patch('CustomData/Tab', {
                            Model: {
                                entityVersion: appAreaTab.entityVersion,
                                objectStateEnum: ObjectStateEnum.Deleted
                            }
                        }, appAreaTab.tab_TId)
                        .then(() => this.searchTabs())
                        .catch(() => this.busyService.stop());
                });
        }

        /**
         * Change view - Tab View/Control View
         */
        changeView(view: PageViewEnum): void {
            if (view === this.view) {
                return;
            }

            // get latest data for appropriate view
            if (view === PageViewEnum.tab) {
                this.searchTabs();
            } else if (view === PageViewEnum.control) {
                this.searchControls();
            }

            this.view = view;
        }

        get pageViewEnum(): any {
            return PageViewEnum;
        }

        /**
         * Selected controls list changed
         * */
        public changedSelectedControls(control: IUserDefinedControl): void {
            let selectedAppArea: AppAreaEnum = null,
                controls = this.controls(),
                i: number = 0,
                len: number = controls.length;

            while (i < len && selectedAppArea === null) {
                let item = controls[i];

                if (item['selected']) {
                    selectedAppArea = item.appAreaEnum;
                }

                i += 1;
            }

            controls.forEach((item) => {
                if (selectedAppArea) {
                    item['notSameArea'] = item.appAreaEnum !== selectedAppArea;
                } else {
                    item['notSameArea'] = false;
                }
            });
        }
    }

    angular.module('meevo.plugins.userDefinedControls')
        .controller('meevo.plugins.userDefinedControls.UserDefinedControlsController', UserDefinedControlsController);
}
